type Listener = (...args: unknown[]) => void

const _listeners: Record<string, Set<Listener>> = {}

export const eventBus = {
  fire(event: string, ...args: unknown[]) {
    _listeners[event]?.forEach((fn) => fn(...args))
  },
  on(event: string, fn: Listener) {
    if (!_listeners[event]) _listeners[event] = new Set()
    _listeners[event].add(fn)
  },
  off(event: string, fn?: Listener) {
    if (fn) {
      _listeners[event]?.delete(fn)
    } else {
      delete _listeners[event]
    }
  },
}

export function useEventBus() {
  return eventBus
}
